export default "__VITE_ASSET__BtrMi1zE__"